import { Injectable } from '@angular/core';
import * as firebaseAuth from '@angular/fire/auth';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root',
})
export class FirebaseSessionService {
  // 改為欄位，讓專屬測試可以替換 Firebase SDK 呼叫。
  private signIn = firebaseAuth.signInWithCustomToken;
  private signOut = firebaseAuth.signOut;

  constructor(
    private readonly auth: firebaseAuth.Auth,
    private readonly loginService: LoginService
  ) {}

  /**
   * 確保此 Account 直接讀寫 Firestore 時使用對應的 Firebase 身分。
   * 注入的 Auth 是預設 nn-platform Firebase Auth 實例。
   */
  async ensureSession(accountId: number): Promise<void> {
    const uid = String(accountId);
    if (this.auth.currentUser?.uid === uid) {
      await this.auth.currentUser.getIdToken();
      return;
    }

    const customToken = await this.loginService.getFirebaseCustomToken();
    const credential = await this.signIn(this.auth, customToken);
    if (credential.user.uid !== uid) {
      await this.clearSession();
      throw new Error('Firebase account mismatch');
    }
  }

  async clearSession(): Promise<void> {
    await this.signOut(this.auth);
  }
}
